import React from "react";

export const YouTubePlayer = ({ video_id, hasControls, isAutoPlay }) => {
  if (!video_id) return null;

  const allow = [
    'accelerometer',
    'autoplay',
    'clipboard-write',
    'encrypted-media',
    'gyroscope',
    'picture-in-picture',
    'web-share'
  ]

  return (
    <iframe
      width="100%"
      height="auto"
      allowFullScreen
      title="YouTube video player"
      src={`https://www.youtube.com/embed/${video_id}?autoplay=${isAutoPlay ? 1 : 0}&controls=${hasControls ? 1 : 0}`}
      allow={allow.join('; ')}
      referrerPolicy="strict-origin-when-cross-origin"
      className="min-h-[200px] sm:min-h-[280px] md:min-h-[360px] lg:min-h-[200px] xl:min-h-[300px]"
    ></iframe>
  );
};

export default YouTubePlayer;
